import { CrmEndpointModuleConfig } from '@touch4it/ng-swp/endpoint';
import { CrmDictionary } from '@touch4it/ng-swp/core/types';

import packageJson from '../../../package.json';
import { environment } from '~/envs/environment';

export const endpointConfig: CrmEndpointModuleConfig = (() => {
  const httpHeaders: CrmDictionary = {
    'x-app-platform': 'backoffice',
    'x-app-version': packageJson.version,
  };

  return {
    endpoints: [
      {
        name: 'crm',
        baseUrl: environment.api,
        withCredentials: true,
        httpHeaders,
      },
    ],
  };
})();
